import commonApi from './CommonApi.js';
import axios from 'axios';

var qs = require('querystring');

export default {
	getColumnChart: async (parameter) => {
		return await commonApi().get('/v1/factsAndFigures/getColumnChart', {
			params: parameter,
			paramsSerializer: (params) => {
				return qs.stringify(params);
			}
		})
			.then((response) => {
				if (response.status == 200) {
					return response.data;
				} else {
					console.log(response);
					return {};
				}
			})
			.catch((error) => {
				console.log(error)
				return {};
			});
	},
	getAreaColumnChart: async (parameter) => {
		return await commonApi().get('/v1/factsAndFigures/getAreaColumnChart', {
			params: parameter,
			paramsSerializer: (params) => {
				return qs.stringify(params);
			}
		})
			.then((response) => {
				if (response.status == 200) {
					return response.data;
				} else {
					console.log(response);
					return {};
				}
			})
			.catch((error) => {
				console.log(error)
				return {};
			});
	},
	getCountryGroupByYearColumnChart: async (parameter) => {
		return await commonApi().get('/v1/factsAndFigures/getCountryGroupByYearColumnChart', {
			params: parameter,
			paramsSerializer: (params) => {
				return qs.stringify(params);
			}
		})
			.then((response) => {
				if (response.status == 200) {
					return response.data;
				} else {
					console.log(response);
					return {};
				}
			})
			.catch((error) => {
				console.log(error)
				return {};
			});
	},
	getCountryGroupByNameColumnChart: async (parameter) => {
		return await commonApi().get('/v1/factsAndFigures/getCountryGroupByNameColumnChart', {
			params: parameter,
			paramsSerializer: (params) => {
				return qs.stringify(params);
			}
		})
			.then((response) => {
				if (response.status == 200) {
					return response.data;
				} else {
					console.log(response);
					return {};
				}
			})
			.catch((error) => {
				console.log(error)
				return {};
			});
	},
	getObjectivesPieChart: async (parameter) => {
		return await commonApi().get('/v1/factsAndFigures/getObjectivesPieChart', {
			params: parameter,
			paramsSerializer: (params) => {
				return qs.stringify(params);
			}
		})
			.then((response) => {
				if (response.status == 200) {
					return response.data;
				} else {
					console.log(response);
					return {};
				}
			})
			.catch((error) => {
				console.log(error)
				return {};
			});
	},
	getKeywordsColumnChart: async (parameter) => {
		return await commonApi().get('/v1/factsAndFigures/getKeywordsColumnChart', {
			params: parameter,
			paramsSerializer: (params) => {
				return qs.stringify(params);
			}
		})
			.then((response) => {
				if (response.status == 200) {
					return response.data;
				} else {
					console.log(response);
					return {};
				}
			})
			.catch((error) => {
				console.log(error)
				return {};
			});
	},
	getSPSInternationalStandardsColumnChart: async (parameter) => {
		return await commonApi().get('/v1/factsAndFigures/getSPSInternationalStandardsColumnChart', {
			params: parameter,
			paramsSerializer: (params) => {
				return qs.stringify(params);
			}
		})
			.then((response) => {
				if (response.status == 200) {
					return response.data;
				} else {
					console.log(response);
					return {};
				}
			})
			.catch((error) => {
				console.log(error)
				return {};
			});
	},
	getSPSTradeFacilitatingMeasuresColumnChart: async (parameter) => {
		return await commonApi().get('/v1/factsAndFigures/getSPSTradeFacilitatingMeasuresColumnChart', {
			params: parameter,
			paramsSerializer: (params) => {
				return qs.stringify(params);
			}
		})
			.then((response) => {
				if (response.status == 200) {
					return response.data;
				} else {
					console.log(response);
					return {};
				}
			})
			.catch((error) => {
				console.log(error)
				return {};
			});
	},
	getTopSubmittingMembers: async (parameter) => {
		return await commonApi().get('/v1/factsAndFigures/getTopSubmittingMembers', {
			params: parameter,
			paramsSerializer: (params) => {
				return qs.stringify(params);
			}
		})
			.then((response) => {
				if (response.status == 200) {
					return response.data;
				} else {
					console.log(response);
					return {};
				}
			})
			.catch((error) => {
				console.log(error)
				return {};
			});
	},
	getSPSData: async (parameter) => {
		return await commonApi().get('/v1/factsAndFigures/getSPSData', {
			params: parameter,
			paramsSerializer: (params) => {
				return qs.stringify(params);
			}
		})
			.then((response) => {
				if (response.status == 200) {
					return response.data;
				} else {
					console.log(response);
					return {};
				}
			})
			.catch((error) => {
				console.log(error)
				return {};
			});
	},
	getTBTData: async (parameter) => {
		return await commonApi().get('/v1/factsAndFigures/getTBTData', {
			params: parameter,
			paramsSerializer: (params) => {
				return qs.stringify(params);
			}
		})
			.then((response) => {
				if (response.status == 200) {
					return response.data;
				} else {
					console.log(response);
					return {};
				}
			})
			.catch((error) => {
				console.log(error)
				return {};
			});
	},	
	getDataForSPS: async (parameter) => {
		let promises = [];		
		let apiList = [
			'getAreaColumnChart',
			'getTopSubmittingMembers',
			'getCountryGroupByYearColumnChart',
			'getCountryGroupByNameColumnChart',
			'getObjectivesPieChart',
			'getKeywordsColumnChart',
			'getSPSInternationalStandardsColumnChart',
			'getSPSTradeFacilitatingMeasuresColumnChart'
		];

		let variables = [
			'mainChart',
			'topSubmittingMember',
			'devStatus',
			'geographic',
			'objective',
			'keyword',
			'internationalStandard',
			'tradeFacilitatingMeasure'
		];

		for (let i = 0; i < apiList.length; i++) {
			promises.push(commonApi().get('/v1/factsAndFigures/' + apiList[i], {
				params: parameter,
				paramsSerializer: (params) => {
					return qs.stringify(params);
				}
			}))
		}
		return await axios.all(promises)
			.then(axios.spread((...args) => {
				let returnValue = {};
				for (let i = 0; i < args.length; i++) {
					returnValue[variables[i]] = args[i].data;
				}
				return returnValue;
			}));
	},
	getDataForTBT: async (parameter) => {		
		let promises = [];
		let apiList = [
			'getAreaColumnChart',
			'getTopSubmittingMembers',
			'getCountryGroupByYearColumnChart',
			'getCountryGroupByNameColumnChart',
			'getObjectivesPieChart'
		];
		
		let variables = [
			'mainChart',
			'topSubmittingMember',
			'devStatus',
			'geographic',
			'objective'
		];
		
		for (let i = 0; i < apiList.length; i++) {
			promises.push(commonApi().get('/v1/factsAndFigures/' + apiList[i], {
				params: parameter,
				paramsSerializer: (params) => {
					return qs.stringify(params);
				}
			}))
		}
		return await axios.all(promises)
			.then(axios.spread((...args) => {
				let returnValue = {};
				for (let i = 0; i < args.length; i++) {
					returnValue[variables[i]] = args[i].data;
				}
				return returnValue;
			}));
	}
}